import type { ReactElement } from 'react';
import classNames from 'classnames';
import Text from 'components/atoms/text/Text';
import Heading from 'components/atoms/heading/Heading';

const Placeholder = ({ componentName }: { componentName: string }): ReactElement => (
  <div
    className={classNames('grid-gutter')}
    style={{
      height: `50vh`,
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'var(--foreground-color)',
      justifyContent: 'center',
      flexDirection: 'column',
      borderTop: 'solid 1px var(--background-color)',
      color: 'var(--background-color)',
      textAlign: 'center',
    }}
  >
    <Heading
      as="h3"
      size="heading-05"
      isVisible={{
        onMount: true,
        value: true,
      }}
    >
      Placeholder
    </Heading>

    <Text
      as="p"
      size="body-large"
      isVisible={{
        onMount: true,
        value: true,
      }}
    >
      The component <strong>{componentName}</strong> has not been created yet.
    </Text>
  </div>
);

export default Placeholder;
